import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Flex, Text } from '@urbaninfrastructure/react-ui-kit'
import { isEdinburgh, isBikeMi } from '../../lib/util'
import EdinburghLogo from './EdinburghLogo'
import DefaultLogo from './DefaultLogo'
import { useTheme } from 'styled-components'
import BikeMiLogo from './BikeMiLogo'

const Logo = ({
  title,
  color,
  companyName,
  displayMode = 'row',
  ...props
}: {
  title: string | null
  companyName: string | null
  color: string
  displayMode?: 'row' | 'column'
}) => {
  const theme = useTheme()
  // edinburgh logo already contains the title, so no need to repeat it
  const _isEdinburgh = isEdinburgh(theme)
  const bikeMi = isBikeMi(theme)

  return (
    <Flex
      alignItems="center"
      flexDirection={displayMode === 'column' ? 'column' : null}
    >
      <Text color={color}>
        {_isEdinburgh && <EdinburghLogo {...props} />}
        {bikeMi && <BikeMiLogo {...props} />}
        {!_isEdinburgh && !bikeMi && (
          <DefaultLogo width={47} height={47} {...props} />
        )}
      </Text>
      {title && (
        <Text ml={3} typoStyle="xxs" color={color}>
          {!_isEdinburgh && !bikeMi && title} {!_isEdinburgh && !bikeMi && '| '}{' '}
          {companyName ? (
            companyName
          ) : (
            <FormattedMessage
              id="components.Logo.title"
              defaultMessage="Business"
            />
          )}
        </Text>
      )}
    </Flex>
  )
}

export default Logo
